var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Page not found")]),_c('p',[_vm._v(" Couldn't find the page you are looking for. ")]),_c('b-button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go back?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }